import { defineComponent, ref, reactive } from "vue";
import Description from "@/components/dialogs/description/Description.vue";
import { currentSiteId } from "@/extensions/extra";
import { ContentModel } from "@/models/content";
import { GET_CONTENT } from "@/services/content-service";
import { returnErrors } from "@/utils/returnErrors";
import { notifyError } from "@/utils/notifier.js";

export default defineComponent({
  name: "Breadcrumbs",
  props: ["BreadcrumbsData", "originalUrl"],
  components: {
    Description,
  },

  setup(props) {
    const data = ref(props.BreadcrumbsData);
    const state = reactive({
      dialogValues: {
        description: false,
      },
    });
    const originalURL = ref(props.originalUrl);
    const contentModel = new ContentModel();
    const description = ref();

    async function getContent() {
      contentModel.currentSiteId = currentSiteId;
      contentModel.originalUrl = props.originalUrl;
      description.value = "";
      const [error, response] = await GET_CONTENT(contentModel);
      if (error) {
        const errorMessage: any = returnErrors(error);
        notifyError(false, errorMessage, "negative", "report_problem");
      } else {
        description.value = response.list.description;
        notifyError(false, description.value, "blue", "info");
      }
    }

    return {
      data,
      state,
      originalURL,
      getContent,
    };
  },
});
